import React from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Select from '../_Shared/SearchableDropdown';
import LinearProgress from '@material-ui/core/LinearProgress';

import AppContent from '../_Shared/Layout/AppContent';

const _ = require('lodash');

class WebsiteEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            website: props.website
        }
    }

    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { website } = this.props;
        if (website !== null && !_.isEqual(prevProps.website, website)) {
            this.setState({ website });
        }
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { website: Object.assign({}, prevState.website, { [name]: value }) }
        });
    }

    updateWebsite = e => {
        const { onWebsiteUpdated } = this.props;
        const { website } = this.state;
        onWebsiteUpdated(Object.assign({}, website));
    }

    render() {
        const { channels, purchaseModels, loading, channelsLoading, purchaseModelsLoading } = this.props;
        const { website } = this.state;
        return (<AppContent>
            <Grid container spacing={24}>
                {
                    loading &&
                    <Grid container item spacing={24}><Grid item xs><LinearProgress variant="query" color="secondary" /></Grid></Grid>
                }

                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <TextField autoFocus value={website.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Website Name" type="text" fullWidth />
                    </Grid>
                </Grid>

                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <Select options={[].concat(!channelsLoading && channels).map(x => { return { 'label': x.name, 'value': x.id } })} value={website.channelId} name="channelId" label="Channel"
                            onChange={value => this.handleInputChange('channelId', value)} placeholder={channelsLoading ? "Loading Channels..." : "Please select a Channel"} />
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <Select options={[].concat(!purchaseModelsLoading && purchaseModels).map(x => { return { 'label': x.name, 'value': x.id } })}
                            value={[].concat(website.purchaseModelIds).join(',')} name="purchaseModelIds" label="Purchase Models"
                            onChange={value => this.handleInputChange('purchaseModelIds', value.split(','))} multiple={true}
                            placeholder={purchaseModelsLoading ? "Loading Purchase Models..." : "Please select a Purchase Model"} />
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <Button onClick={this.updateWebsite} variant="contained" color="secondary">Save</Button>
                    </Grid>
                </Grid>
            </Grid>
        </AppContent >)
    }
}
export default WebsiteEdit;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Websites/WebsiteEdit.js